import template from './institution-home.html';
import './institution-home.scss';

export default angular
  .module('doxy.components.institution-home', [])
  .component('institutionHome', {
    template,
    bindings: {
      institution: '<currentInstitution',
      rooms: '<',
      previewer: '<',
    },
    controller: function (
      $rootScope,
      $state,
      Auth,
      notificationFactory,
      trackingFactory,
      $translate
    ) {

      const trackRoom = (room, segmentEventName) => {
        if (!room) return;
        trackingFactory.global.track(segmentEventName, {
          user_type: 'patient',
          room_id: room.id,
          plan_type: undefined,
        });
      };

      this.$onInit = function () {
        // Safety check for required bindings
        if (!this.institution || !this.rooms) {
          console.warn('institutionHome: institution or rooms not available');
          return;
        }

        // Update page meta after bindings are available
        if (!this.previewer) {
          $rootScope.$emit('updatePageMeta', {
            title: $translate.instant('auth.institution.meta.title', {
              name: this.institution.name,
            }),
            description: $translate.instant('auth.institution.meta.description', {
              name: this.institution.name,
            }),
          });
        }

        this.sortedRooms = [...this.rooms].sort((room1, room2) => {
          return room1.optionNameOnLandingPage.localeCompare(
            room2.optionNameOnLandingPage
          );
        });
      };

      this.getRoomName = (room) => {
        return room.optionNameOnLandingPage.trim();
      };

      this.enterRoom = () => {
        if (this.previewer) return;

        trackingFactory.global.track('Room Entered', {
          room_id: this.room.id,
          user_type: 'patient',
          plan_type: undefined,
        });

        $state.go('patient', { roomSlug: this.room.slug });
      };

      this.onSelect = (room) => {
        this.room = room;
      };

      this.onSelectFromList = (room) => {
        trackRoom(room, 'Room Selected');
      };

      this.loginWithSAML = () => {
        if (this.previewer) return;
        Auth.loginWithProvider('institution/SAML2', {
          institutionId: this.institution.id,
        })
          .then(() => {
            $state.go('account.dashboard');
          })
          .catch((err) => {
            notificationFactory.showCommon('info', err.data.error.message);
          });
      };
    },
  }).name;
